"use client";
import RightSectionTopbar from "./RightSectionTopbar";
import LeftSectionTopbar from "./LeftSectionTopbar";

const flexItems = "flex items-center";
function Topbar() {
  return (
    <div
      className={`h-20 ${flexItems} lg:border-0 border-b  xxl:container xxl:mx-auto  border-ws-gray-200 justify-between xxl:px-0  px-16 py-5  topbar-section relative`}
    >
      <RightSectionTopbar />
      <LeftSectionTopbar />
    </div>
  );
}

export default Topbar;
